import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import HeaderLayout from "../header/HeaderLayout.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MainLayout',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderLayout),
                _createElementVNode("main", null, [
                    _renderSlot(_ctx.$slots, "default")
                ])
            ], 64));
        };
    }
});
